import { SyntheticEvent, useState, useRef } from 'react'
import { FileRejection, DropEvent } from 'react-dropzone'

import { UseHelpersParams, UseHelpersInterface } from './interface'

const useHelpers = ({
  onChange,
  onRemoveFile,
  onDrop,
  maxFiles,
  onMaxFiles,
}: UseHelpersParams): UseHelpersInterface => {
  const [currentFiles, setCurrentFiles] = useState<File[]>([])
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChange = (value: File[]): void => {
    if (onChange && value) onChange(value)
  }

  const handleRemoveFile = (value: File[]): void => {
    if (onRemoveFile && value) onRemoveFile(value)
  }

  const handleDrop = async (
    value: File[],
    fileRejection: FileRejection[],
    event: DropEvent
  ): Promise<void> => {
    if (onDrop) onDrop(value, fileRejection, event)

    if (!value.length) return

    if (currentFiles.length + value.length > maxFiles && onMaxFiles) {
      onMaxFiles()
      return
    }

    let files = value

    if (currentFiles.length > 0 && currentFiles.length < maxFiles) {
      const newFiles = [...currentFiles, ...value]
      files = newFiles
    }

    setCurrentFiles(files)
    handleChange(files)
  }

  const removeFile =
    (index: number) =>
    (
      e: SyntheticEvent<HTMLButtonElement>,
      afterRemove: (files: File[]) => void
    ): void => {
      e.stopPropagation()
      e.preventDefault()

      if (inputRef.current) {
        inputRef.current.value = ''
        inputRef.current.files = null
      }

      const newFiles = [...currentFiles]
      newFiles.splice(index, 1)

      setCurrentFiles(newFiles)
      handleRemoveFile(newFiles)
      afterRemove(newFiles)
    }

  return {
    files: currentFiles,
    ref: inputRef,
    removeFile,
    handleDrop,
  }
}

export default useHelpers
